export class UvozIzvoda{
    
    constructor(){        
    }

    IzvodID: number = null;
    RB: number = null;
    ZiroRacunFirme: string = null;
    ZiroRacunKomitenta: string = null;
    KomitentID: number = null;
    BrojFakture: string = null;
    Duguje :number = null;
    Potrazuje: number = null;
    Opis: string = null;
    OrgJedID: number = null;
    PozivNaBrojOdobrenja: string = null;
    SifraPlacanja: string = null;

    Deserialize(input:any){
        this.IzvodID = input.IzvodID;
        this.RB = input.RB;
        this.ZiroRacunFirme = input.ZiroRacunFirme;
        this.ZiroRacunKomitenta = input.ZiroRacunKomitenta;
        this.KomitentID = input.KomitentID;
        this.BrojFakture = input.BrojFakture;
        this.Duguje = input.Duguje;
        this.Potrazuje = input.Potrazuje;
        this.Opis = input.Opis;
        this.OrgJedID = input.OrgJedID;
        this.PozivNaBrojOdobrenja = input.PozivNaBrojOdobrenja;
        this.SifraPlacanja = input.SifraPlacanja;
        return input;
    }
    
}